import { createContext, useContext } from 'react';
export const ABContext = createContext({});
export const useABContextWrapper = () => useContext(ABContext);
//# sourceMappingURL=ABContext.js.map